import { useDialog } from "@/client/stores/dialog";
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Form,
  FormField,
  FormItem,
  FormLabel,
  Input,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  FormControl,
  SelectValue,
  SelectTrigger,
  ScrollArea,
} from "@reactive-resume/ui";
import { useRef } from "react";
import { useForm } from "react-hook-form";
import { SelectFormField } from "../_components/select-form-fields";
import { useFilterDownload } from "@/client/stores/filter";
import { FilterDownloadType } from "libs/dto/src/download";
import { Role } from "@reactive-resume/utils";
import { usefilterUser } from "@/client/services/user/filter-user";

type StringFilterCondition = "startsWith" | "contains" | "equals" | "endsWith";
type DateFilterCondition = "gt" | "gte" | "equals" | "lt" | "lte";

type DownloadFilterFormType = {
  userName?: {
    condition: StringFilterCondition;
    value: string;
  };
  userEmail?: {
    condition: StringFilterCondition;
    value: string;
  };
  date?: {
    condition: DateFilterCondition;
    value: string;
  };
};

const ObjectConversionToFilterType = (object: DownloadFilterFormType) => {
  const filter: FilterDownloadType = {};
  Object.entries(object).forEach(([key, field]) => {
    if (!field || field.value == null || Number.isNaN(field.value) || field.value === "") return;

    filter[key as keyof DownloadFilterFormType] = {
      [field.condition]: field.value,
    };
  });
  return filter;
};

export const FilterDownloadDialog = () => {
  const { isOpen, close } = useDialog("filter-download");
  const { filter, replaceFilter } = useFilterDownload();
  //  const { filterUsers, isLoading } = usefilterUser(Role.ExtenalUser);

  const form = useForm<DownloadFilterFormType>({
    defaultValues: {
      userName: {
        condition: "contains",
        value: "",
      },
      userEmail: {
        condition: "contains",
        value: "",
      },
      date: {
        condition: "equals",
        value: "",
      },
    },
  });

  const onSubmit = (data: any) => {
    const filterData = ObjectConversionToFilterType(data);
    //console.log(filterData)
    replaceFilter(filterData);
    form.reset();
    close();
  };

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{"Filtrer les téléchargements"}</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Nom d'utilisateur"
                  form={form}
                  condition="String"
                  nameField="userName.condition"
                />
                <Input {...form.register("userName.value")} />
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Email"
                  form={form}
                  condition="String"
                  nameField="userEmail.condition"
                />
                <Input {...form.register("userEmail.value")} />
              </div>
            </div>

            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Date"
                  form={form}
                  condition="Date"
                  nameField="date.condition"
                />
                <Input {...form.register("date.value")} type="date" />
              </div>
            </div>

            <div className="flex justify-center gap-x-3">
              <Button type="submit" className="bg-moncvpro-secondary">
                {"Valider"}
              </Button>
            </div>
          </form>
        </Form>
      </DialogContent>
      <DialogFooter></DialogFooter>
    </Dialog>
  );
};
